import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getEmailTemplates = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/email-templates`, { params });
};

export const getEmailTemplateTypes = async () => {
  return await axios.get(`${baseURL}/email-template-types`);
};

export const createEmailTemplate = async (params) => {
  return await axios.post(`${baseURL}/create-email-template`, params);
};

export const sendEmail = async (body) =>
  await axios.post(`${baseURL}/send-email`, body);

export const sendAllEmailData = (body) =>
  axios.post(`${baseURL}/send-email`, body);
